import React from 'react';
import { useLocaleContext } from '../../../../../context/LocaleContext';
import { useModalContext } from '../../../../../context/ModalContext';
import { useScheduleContext } from '../../../../../context/ScheduleContext';
import { useEventContext } from '../../../../../context/EventContext';
import MemberInfoCard from '../../../../Members/MembersComponents/MemberInfoCard';
import MemberDetailsModal from '../../../../Members/MembersComponents/MemberDetailsModal';
import './style.scss';

const ScheduleMemberFullInfo = ({episode, hasPhotos = true, hasNames = true}) => {
    const $locale = useLocaleContext();
    const {renderModal} = useModalContext();
    const {event} = useEventContext();
    const {moduleEpisode} = event || {};
    const {isWidget, widgetSettings, page} = useScheduleContext();

    if (!moduleEpisode?.membersEnabled) return null;

    return(
        <div className="schedule-members-full">
            {
                !!episode?.groups?.length &&
                episode?.groups.map((group) => (
                    group.hideOnPlatform || (!hasPhotos && !hasNames) || group?.members?.every(({ member }) => member.hide)
                    ? <React.Fragment key={group.id}></React.Fragment>
                    : <div
                        key={group.id}
                        className="schedule-members-full__container"
                    >
                        <h3 className="schedule-members-full__container-title">
                            {$locale.getProperty(group.role, group?.members?.length > 1 ? 'groupTitle' : 'title')}:
                        </h3>
                        <div
                            className="schedule-members-full__container-list"
                            style={{
                                flexDirection: episode.displayMembersVerticalInExpanded ? 'column' : 'row',
                            }}
                        >
                            {
                                group?.members?.sort((a, b) => (a.important === b.important)? 0 : a.important? -1 : 1)
                                .filter(({ member }) => !member.hide)
                                .map((episodeMember) => (
                                    <MemberInfoCard
                                        key={episodeMember.id}
                                        episodeMember={episodeMember}
                                        episode={episode}
                                        group={group}
                                        size="sm"
                                        hasPhoto={hasPhotos}
                                        hasName={hasNames}
                                        onMemberClick={(member) => {
                                            renderModal(
                                                MemberDetailsModal,
                                                {member, lockPageScroll: false, settings: isWidget ? widgetSettings : page?.settings ?? null},
                                                null,
                                                (isWidget ? widgetSettings?.showMemberPopup : true)
                                            )
                                        }}
                                    />
                                ))
                            }
                        </div>
                    </div>
                ))
            }
        </div>
    )
};

export default ScheduleMemberFullInfo;
